import { actionCreator } from '../actionCreator'
export const SEND_TOAST = 'SEND_TOAST'
export const CLEAR_TOAST_DATA = 'CLEAR_TOAST_DATA'

export default {
  ...actionCreator({
    SendToast: SEND_TOAST,
    ClearToastData: CLEAR_TOAST_DATA
  })
}
